module.exports = __webpack_public_path__ + "41816eab91f0762c9433d3370dbaac51.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ClanWebPro-Bold.woff
// module id = 621
// module chunks = 0